import { observer } from "mobx-react-lite";
import * as React from "react";
import { testSpecRelations } from "src/business/specification";
import { PageUrl } from "src/routes/PageUrl";

import {
  ManagementSpecCommonList,
  ManagementSpecCommonListStore,
} from "../ManagementSpecCommon";
import { ObjectsManager } from "../ObjectsManager";

/* eslint no-restricted-syntax: "off" */
/* eslint no-await-in-loop: "off" */

const beforeDelete = async (ids: string[], names: Record<string, string>) => {
  // Предварительная проверка, нет ли спецификаций, которые используются
  for (const id of ids) {
    const res = await testSpecRelations(id, "secondary");
    if (res.hasRelations) {
      const name = names[id] ?? id;
      throw Error(
        `Нельзя удалить спецификацию "${name}", пока она используется.`,
      );
    }
  }
};

const pageStore = new ManagementSpecCommonListStore({
  specType: "secondary",
  beforeDelete,
});

export const ManagementSecondSpecs: React.FC = observer(() => (
  <ObjectsManager tab="secondSpecs">
    <ManagementSpecCommonList
      cardUrl={PageUrl.managementSecondSpecCard}
      pageStore={pageStore}
    />
  </ObjectsManager>
));
